import {Button} from 'brand/Button'

export const ClosePopup = ({children, onClose}) => (
  <header>
    <div className="title">{children}</div>
    <Button size="icon" action={onClose}>✕</Button>
  </header>
)
